export default __webpack_public_path__ + "static/media/stevie_peoples_choice_award_logo_2019.867a3aac.png";